export default __webpack_public_path__ + "static/media/brand.bd4f5d05.jpg";